<template>
  <div>
    <div class="row" v-if="labelPosition === 'left'">
      <div class="col-md-4">
        <label
          class="form-control-label"
          :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
        >{{control.label}}</label>
      </div>
      <div class="col-md-8">
        <b-form-input
          v-if="!control.isMultiLine"
          v-model.trim="$v.value.$model"
          :class="{ 'is-invalid': $v.value.$error }"
          :name="control.fieldName"
          :readonly="this.control.readonly"
          @change="changed"
        />
        <b-form-textarea
          v-else
          v-model.trim="$v.value.$model"
          :class="{ 'is-invalid': $v.value.$error }"
          :name="control.fieldName"
          :readonly="this.control.readonly"
          @change="changed"
        />
        <b-form-invalid-feedback v-if="!$v.value.required">{{ control.label }} is required</b-form-invalid-feedback>
      </div>
    </div>
    <div v-else>
      <label
        class="form-control-label"
        :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
      >{{control.label}}</label>
      <b-form-input
        v-if="!control.isMultiLine"
        v-model.trim="$v.value.$model"
        :class="{ 'is-invalid': $v.value.$error }"
        :name="control.fieldName"
        :readonly="this.control.readonly"
        @change="changed"
      />
      <b-form-textarea
        v-else
        v-model.trim="$v.value.$model"
        :class="{ 'is-invalid': $v.value.$error }"
        :name="control.fieldName"
        :readonly="this.control.readonly"
        @change="changed"
      />
      <b-form-invalid-feedback v-if="!$v.value.required">{{ control.label }} is required</b-form-invalid-feedback>
    </div>
  </div>
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators'
import { Hooks } from '@/components/DataGrid/FormBuilder/gui/components/hook_lists'

export default {
  name: 'TextControl',
  props: ['control', 'labelPosition'],
  data() {
    return {
      value: this.control.value,
    }
  },
  watch: {
    value(value) {
      this.control.value = value
    },
    'control.value'() {
      this.value = this.control.value
    },
  },
  computed: {
    isRequired() {
      return this.control.required
    },
  },
  methods: {
    changed(event) {
      if (this.$v.value.$error) return

      const fbInst = this.$instByClass(this, 'form-builder-root')

      fbInst.setRowDataVal(this.control.propName, this.control.value)
    },
    onValidateHandler() {
      this.$v.value.$touch()
    },
  },
  mounted() {
    if (!this.control.value && !_.isEmpty(this.control.defaultValue)) {
      this.control.value = this.control.defaultValue
    }

    // after hook
    Hooks.Control.afterInit.run(
      this.control,
      $(this.$el).find(this.control.isMultiLine ? 'textarea' : 'input')
    )

    const fbInst = this.$instByClass(this, 'form-builder-root')

    fbInst.$on('validate', this.onValidateHandler)
  },
  beforeDestroy() {
    const fbInst = this.$instByClass(this, 'form-builder-root')

    fbInst.$off('validate', this.onValidateHandler)
  },
  validations: {
    value: {
      required: requiredIf('isRequired'),
    },
  },
}
</script>
